import { paginationFragment } from './fragments/pagination';

const listFragment = `
  id
  hashId
  name
  email
  role
  emailVerified
  lastActive
  slug
  company {
    id
    name
    defaultDomain
  }
  divisions {
    id
    name
  }
  communities {
    id
    name
  }
  projects {
    id
    name
  }
`;

const detailFragment = `
  id
  hashId
  slug
  firstName
  lastName
  name
  email
  phones
  role
  emailVerified
  company {
    id
    name
    defaultDomain
    enableHomeRental
    enableVerifiedBuyingPower
  }
  city {
    id
    name
  }
  createdAt
  updatedAt
  lastActive
  enabledNotifications
  imageUrl
  jobTitle
  linkedInUrl
  divisions {
    id
    name
  }
  communities {
    id
    name
    divisionId
  }
  projects {
    id
    name
    divisionId
  }
  salesProfileSettings {
    showSaveContactButton
    showViewListingsButton
    showEmailButton
    showCallButton
    showLinkedInButton
    customLinks {
      title
      url
      isActive
    }
  }
  invitationSentAt
  welcomeEmailSentAt
  teamAssignments {
    team {
      id
      name
    }
    permission
  }
  userAssignments {
    assignableId
    assignableType
    forInventory
  }
  salesAppAccessEnabled
  isTestAccount
  inventoryVisibilityMode
`;

export const listUsersQuery = `
  query ListUsers(
    $filter: UserFilterInput
    $sort: SortInput
    $page: Int
    $pageSize: Int
  ) {
    result: listUsers(filter: $filter, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ${listFragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const getProfileQuery = `
  query GetProfile {
    profile {
      id
      hashId
      slug
      firstName
      lastName
      name
      email
      role
      phones
      userIp
      company {
        id
        name
        defaultDomain
      }
      columnSettings {
        customers
        quickPossessions
        units
      }
      communityIds
      projectIds
      imageUrl
      jobTitle
      divisions {
        id
        name
      }
      communities {
        id
        name
      }
      projects {
        id
        name
      }
      salesAppAccessEnabled
    }
  }
`;

export const getUserQuery = `
  query GetUser($id: Int!) {
    item: getUser(id: $id) {
      ${detailFragment}
    }
  }
`;

export const createUserQuery = `
  mutation CreateUser(
    $input: CreateUserInput!
    $image: Upload
  ) {
    item: createUser(input: $input, image: $image) {
      ${detailFragment}
    }
  }
`;

export const updateUserQuery = `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $image: Upload
  ) {
    item: updateUser(input: $input, image: $image) {
      ${detailFragment}
    }
  }
`;

export const deleteUserQuery = `
  mutation DeleteUser(
    $id: Int!
  ) {
    item: deleteUser(id: $id) {
      ${detailFragment}
    }
  }
`;

export const changePasswordQuery = `
  mutation ChangePassword(
    $input: ChangePasswordInput!
  ) {
    changed: changePassword(input: $input)
  }
`;

export const listSalesRepsQuery = `
  query ListUsers(
    $filter: UserFilterInput
    $sort: SortInput
    $page: Int
    $pageSize: Int
  ) {
    result: listUsers(filter: $filter, sort: $sort, page: $page, pageSize: $pageSize) {
      items {
        id
        name
        email
      }
    }
  }
`;

export const validateUserBasicInfoQuery = `
  query ValidateUserBasicInfo(
    $input: UserBasicInfoInput!
    $image: Upload
  ) {
    isValid: validateUserBasicInfo(input: $input, image: $image)
  }
`;

export const sendUserWelcomeEmailQuery = `
  query SendUserWelcomeEmail(
    $id: Int!
  ) {
    sent: sendUserWelcomeEmail(id: $id)
  }
`;

export const sendUserInvitationEmailQuery = `
  query SendUserInvitationEmail(
    $id: Int!
  ) {
    sent: sendUserInvitationEmail(id: $id)
  }
`;
